import type { FunctionComponent } from 'react';
import {
  AcademicCapMd,
  AirconReverseLg,
  AlarmMd,
  BalconyLg,
  BathLg,
  BathMd,
  BedMd,
  BedLg,
  BuildingCoverageMd,
  BusMd,
  CarLg,
  CarportLg,
  CarSpaceOpenLg,
  CouchLg,
  CourtyardLg,
  DeckLg,
  DeskMd,
  DishwasherLg,
  DocumentLg,
  DocumentMd,
  DogMd,
  DuctedCoolingLg,
  DuctedHeatingLg,
  DuctedVacuumLg,
  ElectricHeatingLg,
  ElectricHotWaterLg,
  ElevationMd,
  EvaporativeCoolingLg,
  ExternalLinkMd,
  FenceLg,
  FirePlaceLg,
  FloorboardsLg,
  FloorplanMd,
  FloorplanLg,
  GarageLg,
  GasHotWaterLg,
  GasLg,
  GreyWaterSystemLg,
  GymLg,
  HammerLg,
  HeatPumpLg,
  HomeLg,
  HomeMd,
  HydronicHeatingLg,
  IntercomLg,
  LandSizeLg,
  LandSizeMd,
  LinkMd,
  LinkLg,
  PencilMd,
  PhoneLg,
  RemoteGarageLg,
  RemoteLg,
  RoofHeightMd,
  RumpusRoomLg,
  SecureParkingLg,
  ShedLg,
  ShopLg,
  ShowerLg,
  SnowflakeMd,
  SolarHotWaterLg,
  SolarPanelsLg,
  SoldMd,
  SoldLg,
  SpaInsideLg,
  SpaOutdoorLg,
  SplitSystemCoolingLg,
  SplitSystemHeatingLg,
  StarMd,
  SuccessMd,
  SunMd,
  SwimmingPoolIngroundMd,
  SwimmingPoolOvergroundLg,
  TennisBallLg,
  ToiletLg,
  WardrobeLg,
  WaterTankLg,
  IphoneMd,
} from '@property.com.au/ui-kit';
import { IconName, Icon } from '../types';

const mapIcons: Record<IconName, Icon> = {
  AcademicCapMd,
  AirconReverseLg,
  AlarmMd,
  BalconyLg,
  BathLg,
  BathMd,
  BedMd,
  BedLg,
  BuildingCoverageMd,
  BusMd,
  CarLg,
  CarportLg,
  CarSpaceOpenLg,
  CouchLg,
  CourtyardLg,
  DeckLg,
  DeskMd,
  DishwasherLg,
  DocumentLg,
  DocumentMd,
  DogMd,
  DuctedCoolingLg,
  DuctedHeatingLg,
  DuctedVacuumLg,
  ElectricHeatingLg,
  ElectricHotWaterLg,
  ElevationMd,
  EvaporativeCoolingLg,
  ExternalLinkMd,
  FenceLg,
  FirePlaceLg,
  FloorboardsLg,
  FloorplanMd,
  FloorplanLg,
  GarageLg,
  GasHotWaterLg,
  GasLg,
  GreyWaterSystemLg,
  GymLg,
  HammerLg,
  HeatPumpLg,
  HomeLg,
  HomeMd,
  HydronicHeatingLg,
  IntercomLg,
  IphoneMd,
  LandSizeLg,
  LandSizeMd,
  LinkMd,
  LinkLg,
  PencilMd,
  PhoneLg,
  RemoteGarageLg,
  RemoteLg,
  RoofHeightMd,
  RumpusRoomLg,
  SecureParkingLg,
  ShedLg,
  ShopLg,
  ShowerLg,
  SnowflakeMd,
  SolarHotWaterLg,
  SolarPanelsLg,
  SoldMd,
  SoldLg,
  SpaInsideLg,
  SpaOutdoorLg,
  SplitSystemCoolingLg,
  SplitSystemHeatingLg,
  StarMd,
  SuccessMd,
  SunMd,
  SwimmingPoolIngroundMd,
  SwimmingPoolOvergroundLg,
  TennisBallLg,
  ToiletLg,
  WardrobeLg,
  WaterTankLg,
};

export const PropertyFeatureIcon: FunctionComponent<{
  iconName: IconName;
  title: string;
}> = ({ iconName, title }) => {
  const MappedIcon = mapIcons[iconName] ?? mapIcons.HomeMd;
  return (
    <MappedIcon
      style={{
        width: '16px',
        height: '16px',
      }}
      strokeWidth={1.25}
      title={title}
      id={`${title}-icon`}
    />
  );
};
